import { Component, OnInit } from '@angular/core';
import { ReportService } from 'src/app/services/report.service';
import { NgbDateAdapter, NgbDateNativeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-travel-paysheet-report',
  templateUrl: './travel-paysheet-report.component.html',
  styleUrls: ['./travel-paysheet-report.component.css'],
  providers: [{provide: NgbDateAdapter, useClass: NgbDateNativeAdapter}]
})
export class TravelPaysheetReportComponent implements OnInit {
  date1:Date = new Date();
  date2:Date = new Date();
  data:any = [];
  loading:boolean = false;
  total:number = 0;
  totalNomina:number = 0;
  totalViajes:number = 0;
  expand:boolean = false;

  constructor( private repServ:ReportService ) {}

  ngOnInit() {
  }

  search() {
    this.loading = true;
    this.repServ.travelPaysheetReport(this.date1, this.date2).then(resp => {
      this.data = resp;
      this.calculateTotals();
      this.loading = false;
    });
  }

  calculateTotals() {
    this.totalNomina = 0;
    this.totalViajes = 0;
    this.total = 0;

    for (let i = 0; i < this.data.length; i++) {
      this.data[i].paysheet_date = new Date(this.data[i].paysheet_date.substring(0, 10) + ' 12:00:00.00');
      this.data[i].delivery_date = new Date(this.data[i].delivery_date.substring(0, 10) + ' 12:00:00.00');

      this.data[i].validNomina = this.data[i].paysheet_date >= this.date1 && this.data[i].paysheet_date <= this.date2 && this.data[i].in_cash;
      this.data[i].validViajes = this.data[i].delivery_date >= this.date1 && this.data[i].delivery_date <= this.date2;

      this.totalNomina += this.data[i].validNomina ? this.data[i].price*1 : 0;
      this.totalViajes += this.data[i].validViajes ? this.data[i].price*1 : 0;
      this.total += this.data[i].price*1;
    }
  }

  download(type) {
    window.open(environment.baseUrl + '/' + type + '/travel-paysheet?date1=' + this.date1.toString() + '&date2=' + this.date2.toString(), '_blank')
  }
}
